import MatchHeight from "vanilla-js-match-height";
const Heights = () => {
    new MatchHeight(".js-post-heading");
    new MatchHeight(".js-card-heading");
    new MatchHeight(".js-card-content");
    new MatchHeight(".js-case-study-category");
    new MatchHeight(".js-case-study-heading");
    new MatchHeight(".js-team-role");
    new MatchHeight(".js-team-name");
    new MatchHeight(".js-team-bio");
};
export { Heights };
